import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
// @ts-expect-error No types
import { getEmbedVersion } from 'FormsUI/selectors/FormDefinition';

// TODO: Update once state is typed

export const getIsV3Form = state => getEmbedVersion(state) === EmbedVersions.V3;